class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.pointerLeaveTimer = null;
    this.nestedPointerLeaveTimers = new WeakMap();

    if (!HeaderMenu.documentClickBound) {
      document.addEventListener('click', HeaderMenu.closeMenusOnDocumentClick);
      HeaderMenu.documentClickBound = true;
    }

    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.addEventListener('click', this.onMenuClick.bind(this));

    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.addEventListener('pointerenter', this.onNestedPointerEnter.bind(this));
      details.addEventListener('pointerleave', this.onNestedPointerLeave.bind(this));
    });
  }

  onPointerEnter() {
    window.clearTimeout(this.pointerLeaveTimer);
  }

  onPointerLeave(event) {
    if (!window.matchMedia('(min-width: 990px)').matches || event.pointerType === 'touch') return;

    window.clearTimeout(this.pointerLeaveTimer);
    this.pointerLeaveTimer = window.setTimeout(() => this.close(), 140);
  }

  onNestedPointerEnter(event) {
    const timer = this.nestedPointerLeaveTimers.get(event.currentTarget);
    window.clearTimeout(timer);
  }

  onNestedPointerLeave(event) {
    if (!window.matchMedia('(min-width: 990px)').matches || event.pointerType === 'touch') return;

    const details = event.currentTarget;
    window.clearTimeout(this.nestedPointerLeaveTimers.get(details));
    const timer = window.setTimeout(() => this.closeDetails(details), 140);
    this.nestedPointerLeaveTimers.set(details, timer);
  }

  onMenuClick(event) {
    const summary = event.target.closest('summary');
    if (!summary || !this.contains(summary)) return;

    const selectedDetails = summary.parentElement;
    if (selectedDetails === this.mainDetailsToggle) {
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
      return;
    }

    this.mainDetailsToggle.querySelectorAll('details[open]').forEach((details) => {
      const belongsToSelectedBranch = details === selectedDetails || details.contains(selectedDetails);
      if (!belongsToSelectedBranch) this.closeDetails(details);
    });
  }

  static closeMenusOnDocumentClick(event) {
    if (event.target.closest('header-menu')) return;
    document.querySelectorAll('header-menu').forEach((menu) => menu.close());
  }

  closeDetails(details) {
    window.clearTimeout(this.nestedPointerLeaveTimers.get(details));
    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', false);
  }

  closeNestedMenus() {
    this.mainDetailsToggle.querySelectorAll('details[open]').forEach((details) => this.closeDetails(details));
  }

  close() {
    window.clearTimeout(this.pointerLeaveTimer);
    this.closeNestedMenus();
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
    } else {
      this.closeNestedMenus();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

HeaderMenu.documentClickBound = false;

customElements.define('header-menu', HeaderMenu);
